const getUrlQuery = (pathFech) => {
 
    const url = new URL(window.location.href)
    const urlParams = url.searchParams
    const queryParams = {};
    
    urlParams.forEach((value, key) => {
        queryParams[key] = value;
    });

    let paramsToPath = '';

    let urlValidation = window.location.href;

    if(urlValidation.includes('?') || pathFech.includes('?')){
        paramsToPath = '&' + urlParams.toString()
    }else{
        paramsToPath = '?'+urlParams.toString()
    }

    return {queryParams, paramsToPath}
}

export default getUrlQuery;